import { render, staticRenderFns } from "./InvestmentCard.vue?vue&type=template&id=7ac34a32&"
import script from "./InvestmentCard.vue?vue&type=script&lang=ts&"
export * from "./InvestmentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports